"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backdrop = void 0;
const app_1 = require("@obvio/app");
exports.Backdrop = app_1.styled.div `
  position: absolute;
  top: calc(100% + 1px);
  background: rgba(0, 0, 0, 0.3);
  height: 100vh;
  left: 0;
  right: 0;
  z-index: 4;
  display: ${(_, { $open }) => ($open ? 'block' : 'none')};
`;
